import './resources.css'

const FourthWebinarResource = () => {
    return (
        <ul className= 'additional-resources' >
            <h3> Additional Resources: </h3>
            <li onClick = {() => window.open("https://www.cfsph.iastate.edu/infection-control/disinfection/")}> CFSPH Disinfection Resources (antimicrobial spectrum & characteristics of disinfectants, reading disinfectant labels, disinfection 101, etc.) </li>
            <li onClick={() => window.open("https://www.cfsph.iastate.edu/biosecurity-resource/cleaning-disinfection/")}> Cleaning and Disinfection Biosecurity Tip Sheets (CFSPH) </li>
            <li onClick={() => window.open("https://www.healthyagriculture.org/prevent/sanitation/")}> HFHA Sanitation page </li>
            {/*Nested List */}
            <li onClick={()=> window.open("https://www.cfsph.iastate.edu/Assets/tip-sheet-manure-litter-bedding-management.pdf")}> Manure, Litter & Bedding Management Biosecurity Tip Sheet (CFSPH) </li>
            <li onClick = {() => window.open("https://www.healthyagriculture.org/prevent/traffic-control/manure-handling/")}> HFHA Manure Handling page  </li>
        </ul>
    )
}

export default FourthWebinarResource;